import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import { luxuryEase } from '../lib/motion';

export default function Lightbox({ images, currentIndex, onClose, onNext, onPrev }) {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };

    window.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [onClose, onNext, onPrev]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4, ease: luxuryEase }}
      className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-3 sm:p-6"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        className="absolute top-3 right-3 sm:top-4 sm:right-4 text-white hover:text-nosta-goldSoft transition-colors z-10 p-2"
        aria-label="Kapat"
      >
        <X size={32} />
      </button>

      <button
        onClick={(e) => {
          e.stopPropagation();
          onPrev();
        }}
        className="absolute left-1 sm:left-4 text-white hover:text-nosta-goldSoft transition-colors z-10 p-2 hover:bg-white/10"
        aria-label="Önceki"
      >
        <ChevronLeft size={40} />
      </button>

      <button
        onClick={(e) => {
          e.stopPropagation();
          onNext();
        }}
        className="absolute right-1 sm:right-4 text-white hover:text-nosta-goldSoft transition-colors z-10 p-2 hover:bg-white/10"
        aria-label="Sonraki"
      >
        <ChevronRight size={40} />
      </button>

      <motion.div
        key={currentIndex}
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, ease: luxuryEase }}
        className="max-w-7xl max-h-[82svh] sm:max-h-[90vh] px-10 sm:px-16"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={images[currentIndex]}
          alt={`Görsel ${currentIndex + 1}`}
          className="max-w-full max-h-[72svh] sm:max-h-[90vh] w-auto h-auto object-contain mx-auto photo-lux"
        />
        <div className="text-center mt-4 text-white/40 text-sm tracking-wide">
          {currentIndex + 1} / {images.length}
        </div>
      </motion.div>
    </motion.div>
  );
}
